import Backtop from 'bee-backtop'

export default Backtop
